import { Injectable, inject } from "@angular/core";

import { StateEmitter } from "../../../../common/libraries/emitter/state-emitter";
import { UserCustomizationService } from "../../../../common/services/api/resources/userCustomization/user-customization.service";

const debug = true;

interface Avatar {
  avatar: string;
}

@Injectable({ providedIn: "root" })
export class SignUpAvatarService extends StateEmitter<Avatar> {
  private userCustomization = inject(UserCustomizationService);

  constructor() {
    super({ avatar: "" });
  }

  setAvatar(avatar: string): void {
    debug && console.log("Signup.AvatarService: setAvatar", avatar);
    this.stateStore.avatar = avatar;
    this.publishState();
  }

  saveAvatar(): void {
    debug && console.log("Signup.AvatarService: saveAvatar");
    this.userCustomization.userCustomizationAvatarEdit({ UserAvatar: this.stateValue.avatar });
  }

  get avatar(): string {
    debug && console.log("Signup.AvatarService: getAvatar", this.stateValue.avatar);
    return this.stateValue.avatar || "";
  }
}
